import { modifiedDateCol, modifierGetter } from 'core/HeaderColTypeProps'
import React from 'react'
import { toSelectionColProps } from '@integec/grid-tools/lib/utils'
import R from 'ramda'
import {
  strCol,
  numCol,
  dateCol,
  intCol,
  dateTimeCol,
} from '@integec/grid-tools/lib/cols'

export const modifierCol = {
  ident: 'modifier',
  display: 'Modifier',
  dataGetter: modifierGetter,
  showInRowEditor: false,
  type: 'str',
  width: 200,
  isKey: true,
  ellipsis: true,
}

export const Wind2PerformanceHeaders = (
  avalibilityStatusIdMap,
  subGroupNameMap = [],
  withPlantId = false
) => {
  const headers = [
    // strCol({ ident: 'entityId', display: 'NCR ID/NERC ID', isKey: true }),

    strCol({
      ident: 'subgroupName',
      display: 'Subgroup Name',
      sortOrder: 'asc',
      width: 250,
      ellipsis: true,
      ...toSelectionColProps(subGroupNameMap),
      sortIndexGetter: ({ rowData }) =>
        rowData.subgroupName === 'TOTAL' ? 'ZZZZZZZ' : rowData.subgroupName,
    }),

    strCol({
      ident: 'status',
      display: 'Subgroup Status',
      isFiltered: true,
      // sortOrder: 'asc',
      ...toSelectionColProps(avalibilityStatusIdMap),
    }),
    numCol({
      ident: 'grossactgen',
      display: 'Gross Actual Generation (MWh)',
      isFiltered: true,
      width: 150,
    }),
    numCol({
      ident: 'expectedGen',
      display: 'Expected Generation (MWh)',
      isFiltered: true,
      width: 150,
    }),
    numCol({
      ident: 'netactgen',
      display: 'Net Actual Generation (MWh)',
      isFiltered: true,
      width: 150,
    }),
    numCol({
      ident: 'netmaxcap',
      display: 'Net Max Capacity (MW)',
      isFiltered: true,
    }),
    numCol({
      ident: 'activeThrs',
      display: 'Period (Active) THrs',
      isFiltered: true,
    }),
    numCol({ ident: 'contactThrs', display: 'Contact THrs', isFiltered: true }),
    numCol({
      ident: 'rsThrs',
      display: 'Reserve Shutdown THrs',
      isFiltered: true,
      width: 150,
    }),
    numCol({ ident: 'forcedThrs', display: 'Forced THrs', isFiltered: true }),
    numCol({
      ident: 'maintenanceThrs',
      display: 'Maintenance THrs',
      isFiltered: true,
    }),
    numCol({ ident: 'plannedThrs', display: 'Planned THrs', isFiltered: true }),
    numCol({
      ident: 'ruThrs',
      display: 'Resource Unavailable THrs',
      isFiltered: true,
      width: 150,
    }),
    numCol({
      ident: 'inactiveReserveThrs',
      display: 'Inactive Reserve THrs',
      isFiltered: true,
      width: 120,
    }),
    numCol({
      ident: 'mothballedThrs',
      display: 'Monthballed THrs',
      isFiltered: true,
    }),
    numCol({ ident: 'retiredThrs', display: 'Retired THrs', isFiltered: true }),
    // modifierCol,
    // modifiedDateCol,
  ]
  const plantHeaders = [
    strCol({ ident: 'plantId', display: 'Plant ID', isKey: true }),
    intCol({ ident: 'year', display: 'Year', isKey: true, sortOrder: 'asc' }),
    intCol({ ident: 'month', display: 'Month', isKey: true, sortOrder: 'asc' }),
    strCol({ ident: 'subgroupId', display: 'Subgroup ID', isKey: true }),
  ]
  if (withPlantId) return [...plantHeaders, ...headers]
  return headers
}

export const Wind2PerformanceHeadersModifier = avalibilityStatusIdMap => [
  ...Wind2PerformanceHeaders(avalibilityStatusIdMap),
  modifierCol,
  modifiedDateCol,
]

export const Wind2NercEventHeaders = (
  width,
  contribConditionList,
  eventTypes = [],
  withPlantId = false
) => {
  const conMap = R.compose(
    R.fromPairs,
    R.map(d => [d.contOpCode, d.contOpCode + ' - ' + d.contOpCondition])
  )(contribConditionList)

  const effectiveEvent = R.compose(
    R.fromPairs,
    R.map(d => [d.id, d.id]),
    R.filter(f => f.eventFor === 'N')
  )(eventTypes)

  const headers = [
    //  strCol({ ident: 'entityId', display: 'NCR ID/NERC ID', isKey: true }),
    //
    strCol({
      ident: 'eventId',
      display: 'Event ID',
      isKey: true,
      sortOrder: 'asc',
      ellipsis: true,
    }),
    // strCol({ ident: 'timeZone', display: 'Time Zone', isKey: true }),
    dateTimeCol({
      ident: 'eventstart',
      display: 'Event Start',
      isKey: true,
      width: 200,
      displayFormat: 'MM/DD/YYYY HH:mm',
      dataFormat: 'MM/DD/YYYY HH:mm',
      sortOrder: 'asc',
      isDateWithTime: true,
    }),
    dateTimeCol({
      ident: 'eventend',
      display: 'Event End',
      isFiltered: true,
      width: 200,
      displayFormat: 'MM/DD/YYYY HH:mm',
      dataFormat: 'MM/DD/YYYY HH:mm',
      // sortOrder: 'asc',
      isDateWithTime: true,
    }),
    strCol({
      ident: 'eventtype',
      display: 'Event Type',
      isFiltered: true,
      ...toSelectionColProps(effectiveEvent),
    }),
    intCol({ ident: 'causecode', display: 'Cause Code', isFiltered: true }),
    strCol({
      ident: 'contributingCondition',
      display: 'Contributing Operating Condition',
      isFiltered: true,
      ...toSelectionColProps(conMap),
      alignment: 'left',
      width: 250,
      ellipsis: true,
    }),
  ]

  const lastHeaders = [
    numCol({
      ident: 'potentialLoss',
      display: 'Potential Generation Loss (MWh)',
      isFiltered: true,
      width: 200,
    }),
    modifierCol,
    modifiedDateCol,
  ]

  const getWidth = hd => hd.map(h => h.width || 100).reduce((a, b) => a + b)

  let descwidth = width - getWidth(headers) - getWidth(lastHeaders) - 30
  if (descwidth < 0) descwidth = 150
  const desc = strCol({
    ident: 'description',
    display: 'Event Description',
    isFiltered: true,
    width: descwidth,
    ellipsis: true,
    alignment: 'left',
  })
  const finalHeader = [...headers, desc, ...lastHeaders]
  const plantId = strCol({ ident: 'plantId', display: 'Plant ID', isKey: true })
  if (withPlantId) return [plantId, ...finalHeader]
  return finalHeader
}

// this is for color-table
export const Wind2TmpMonthlyPieHeaders = [
  strCol({ ident: 'item', display: 'Item', isFiltered: true }),
  numCol({ ident: 'percent', display: 'Percent', isFiltered: true }),
  numCol({ ident: 'thrs', display: 'Thrs', isFiltered: true }),
  numCol({ ident: 'red', display: 'Red', isFiltered: true }),
  numCol({ ident: 'green', display: 'Green', isFiltered: true }),
  numCol({ ident: 'blue', display: 'Blue', isFiltered: true }),
]

// this is for rect bar  chart
export const Wind2TmpMonthlyGraphHeaders = [
  strCol({ ident: 'entityId', display: 'EntityId', isFiltered: true }),
  strCol({ ident: 'plantId', display: 'PlantId', isFiltered: true }),
  strCol({ ident: 'eventId', display: 'EventId', isFiltered: true }),
  numCol({ ident: 'startDay', display: 'StartDay', isFiltered: true }),
  numCol({ ident: 'endDay', display: 'EndDay', isFiltered: true }),
  numCol({ ident: 'startPct', display: 'StartPct', isFiltered: true }),
  numCol({ ident: 'endPct', display: 'EndPct', isFiltered: true }),
  numCol({ ident: 'red', display: 'Red', isFiltered: true }),
  numCol({ ident: 'green', display: 'Green', isFiltered: true }),
  numCol({ ident: 'blue', display: 'Blue', isFiltered: true }),
  numCol({ ident: 'seqNo', display: 'SeqNo', isFiltered: true }),
]

// this is for daily graph
export const Wind2TmpDailyHeaders = [
  numCol({ ident: 'daySeqNo', display: 'DaySeqNo', isFiltered: true }),
  numCol({ ident: 'grossactgen', display: 'Grossactgen', isFiltered: true }),
  numCol({ ident: 'expectedGen', display: 'ExpectedGen', isFiltered: true }),
  numCol({ ident: 'netactgen', display: 'Netactgen', isFiltered: true }),

  modifierCol,
  modifiedDateCol,
]

export const Wind2TurbineEventHeaders = (
  width,
  contribConditionList = [],
  eventTypes = [],
  turbineId = [],
  withPlantId = false
) => {
  const conMap = R.compose(
    R.fromPairs,
    R.map(d => [d.contOpCode, d.contOpCode + ' - ' + d.contOpCondition])
  )(contribConditionList)

  const effectiveEvent = R.compose(
    R.fromPairs,
    R.map(d => [d.id, d.id]),
    R.filter(f => f.eventFor === 'T')
  )(eventTypes)

  const turbineIdMap = R.compose(
    R.fromPairs,
    R.map(d => [d.turbineId, d.turbineId])
  )(turbineId)

  const headers = [
    strCol({
      ident: 'turbineId',
      display: 'Turbine ID',
      ...toSelectionColProps(turbineIdMap),
      isKey: true,
      width: 150,
      ellipsis: true,
    }),
    strCol({ ident: 'eventId', display: 'Event ID', isFiltered: true }),
    dateTimeCol({
      ident: 'eventstart',
      display: 'Event Start',
      isKey: true,
      width: 200,
      displayFormat: 'MM/DD/YYYY HH:mm',
      dataFormat: 'MM/DD/YYYY HH:mm',
      isDateWithTime: true,
    }),
    dateTimeCol({
      ident: 'eventend',
      display: 'Event End',
      isFiltered: true,
      width: 200,
      displayFormat: 'MM/DD/YYYY HH:mm',
      dataFormat: 'MM/DD/YYYY HH:mm',
      isDateWithTime: true,
    }),
    strCol({
      ident: 'eventtype',
      display: 'Event Type',
      ...toSelectionColProps(effectiveEvent),
      isFiltered: true,
    }),
    intCol({ ident: 'causecode', display: 'Cause Code', isFiltered: true }),
    strCol({
      ident: 'contributingCondition',
      display: 'Contributing Operating Condition',
      isFiltered: true,
      alignment: 'left',
      width: 250,
      ellipsis: true,
      ...toSelectionColProps(conMap),
    }),
    strCol({
      ident: 'description',
      display: 'Event Description',
      isFiltered: true,
      width: width - 1340 < 0 ? 150 : width - 1340,
      ellipsis: true,
      alignment: 'left',
    }),
    modifierCol,
    modifiedDateCol,
  ]

  const palntId = strCol({
    ident: 'plantId',
    display: 'Plant ID',
    isKey: true,
    width: 150,
    ellipsis: true,
  })

  if (withPlantId) return [palntId, ...headers]
  return headers
}

export const Wind2TurbinePerformanceHeaders = (
  turbineId = [],
  withPlantId = false
) => {
  const turbineIdMap = R.compose(
    R.fromPairs,
    R.map(d => [d.turbineId, d.turbineId])
  )(turbineId)
  const headers = [
    // strCol({ ident: 'entityId', display: 'NCR ID/NERC ID', isKey: true }),

    strCol({
      ident: 'turbineId',
      display: 'Turbine ID',
      isKey: true,
      sortOrder: 'asc',
      width: 150,
      ellipsis: true,
      ...toSelectionColProps(turbineIdMap),
    }),

    // strCol({
    //   ident: 'status',
    //   display: 'Subgroup Status',
    //   isFiltered: true,
    //   sortOrder: 'asc',
    //   ...toSelectionColProps(avalibilityStatusIdMap),
    // }),
    numCol({
      ident: 'grossactgen',
      display: 'Gross Actual Gen (MWh)',
      isFiltered: true,
      width: 120,
    }),
    numCol({
      ident: 'expectedGen',
      display: 'Expected Gen (MWh)',
      isFiltered: true,
      width: 120,
    }),
    numCol({
      ident: 'netactgen',
      display: 'Net Actual Gen (MWh)',
      isFiltered: true,
      width: 120,
    }),
    numCol({
      ident: 'netmaxcap',
      display: 'Net Max Capacity (MW)',
      isFiltered: true,
    }),
    numCol({
      ident: 'activeThrs',
      display: 'Period (Active) THrs',
      isFiltered: true,
    }),
    numCol({ ident: 'contactThrs', display: 'Contact THrs', isFiltered: true }),
    numCol({
      ident: 'rsThrs',
      display: 'Reserve Shutdown THrs',
      isFiltered: true,
      // width: 150,
    }),
    numCol({ ident: 'forcedThrs', display: 'Forced THrs', isFiltered: true }),
    numCol({
      ident: 'maintenanceThrs',
      display: 'Maintenance THrs',
      isFiltered: true,
    }),
    numCol({ ident: 'plannedThrs', display: 'Planned THrs', isFiltered: true }),
    numCol({
      ident: 'ruThrs',
      display: 'Resource Unavail THrs',
      isFiltered: true,
      // width: 130,
    }),
    numCol({
      ident: 'inactiveReserveThrs',
      display: 'Inactive Reserve THrs',
      isFiltered: true,
      width: 120,
    }),
    numCol({
      ident: 'mothballedThrs',
      display: 'Monthballed THrs',
      isFiltered: true,
    }),
    numCol({ ident: 'retiredThrs', display: 'Retired THrs', isFiltered: true }),
    modifierCol,
    modifiedDateCol,
  ]
  const plas = [
    strCol({ ident: 'plantId', display: 'Plant ID', isKey: true }),
    intCol({ ident: 'year', display: 'Year', isKey: true, sortOrder: 'asc' }),
    intCol({ ident: 'month', display: 'Month', isKey: true, sortOrder: 'asc' }),
  ]
  if (withPlantId) return [...plas, ...headers]
  return headers
}
export const Wind2StoragePerformanceIoHeaders = avalibilityStatusIdMap => [
  // strCol({
  //   ident: 'entityId',
  //   display: 'NCR ID/NERC ID',
  //   isFiltered: true,
  //   sortOrder: 'asc',
  // }),
  // strCol({
  //   ident: 'plantId',
  //   display: 'Plant ID',
  //   isFiltered: true,
  //   sortOrder: 'asc',
  // }),
  strCol({
    ident: 'storageGroupId',
    display: 'Inverter Group ID',
    isFiltered: true,
    sortOrder: 'asc',
    width: 150,
    sortIndexGetter: ({ rowData }) =>
      rowData.storageGroupId === 'TOTAL' ? 'ZZZZZZZ' : rowData.storageGroupId,
  }),
  // numCol({
  //   ident: 'year',
  //   display: 'Year',
  //   isFiltered: true,
  //   sortOrder: 'asc',
  // }),
  // numCol({
  //   ident: 'month',
  //   display: 'Month',
  //   isFiltered: true,
  //   sortOrder: 'asc',
  // }),
  strCol({
    ident: 'storageGroupAvailability',
    display: 'Availability Status',
    isFiltered: true,
    sortOrder: 'asc',
    ...toSelectionColProps(avalibilityStatusIdMap),
  }),
  numCol({
    ident: 'chargeMwh',
    display: 'Charge MWh',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'dischargeMwh',
    display: 'Discharge MWh',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'chargeHrs',
    display: 'Charge Hrs',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'dischargeHrs',
    display: 'Discharge Hrs',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'foHrs',
    display: 'FO Hrs',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'moHrs',
    display: 'MO Hrs',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'poHrs',
    display: 'PO Hrs',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  // strCol({
  //   ident: 'recordid',
  //   display: 'Recordid',
  //   isFiltered: true,
  //   sortOrder: 'asc',
  // }),
  // strCol({
  //   ident: 'action',
  //   display: 'Action',
  //   isFiltered: true,
  //   sortOrder: 'asc',
  // }),
]

export const Wind2StoragePerformanceHeaders = [
  strCol({
    ident: 'entityId',
    display: 'EntityId',
    isKey: true,
    sortOrder: 'asc',
    ellipsis: true,
  }),
  strCol({
    ident: 'plantId',
    display: 'PlantId',
    isKey: true,
    sortOrder: 'asc',
    ellipsis: true,
  }),
  strCol({
    ident: 'storageGroupId',
    display: 'StorageGroupId',
    isKey: true,
    sortOrder: 'asc',
  }),
  numCol({ ident: 'year', display: 'Year', isKey: true, sortOrder: 'asc' }),
  numCol({ ident: 'month', display: 'Month', isKey: true, sortOrder: 'asc' }),
  strCol({
    ident: 'storageGroupAvailability',
    display: 'StorageGroupAvailability',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'chargeMwh',
    display: 'ChargeMwh',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'dischargeMwh',
    display: 'DischargeMwh',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'chargeHrs',
    display: 'ChargeHrs',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'dischargeHrs',
    display: 'DischargeHrs',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'foHrs',
    display: 'FoHrs',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'moHrs',
    display: 'MoHrs',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'poHrs',
    display: 'PoHrs',
    isFiltered: true,
    sortOrder: 'asc',
  }),

  modifierCol,
  modifiedDateCol,
]

export const Wind2SubgroupHeaders = [
  strCol({
    ident: 'entityId',
    display: 'EntityId',
    isKey: true,
    ellipsis: true,
  }),
  strCol({ ident: 'plantId', display: 'PlantId', isKey: true, ellipsis: true }),
  strCol({
    ident: 'groupIdName',
    display: 'GroupIdName',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({ ident: 'subgroupId', display: 'SubgroupId', isKey: true }),
  strCol({
    ident: 'subgroupName',
    display: 'SubgroupName',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'elevation',
    display: 'Elevation',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'windRegime',
    display: 'WindRegime',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'annualAvgWindspeed',
    display: 'AnnualAvgWindspeed',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'scadaManufacturer',
    display: 'ScadaManufacturer',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'scadaModel',
    display: 'ScadaModel',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  dateCol({
    ident: 'commissionDate',
    display: 'CommissionDate',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'totalInstalledCap',
    display: 'TotalInstalledCap',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'numberTurbines',
    display: 'NumberTurbines',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'trubineSystemMw',
    display: 'TrubineSystemMw',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'maxTurbineCapacity',
    display: 'MaxTurbineCapacity',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'trubineManufacturer',
    display: 'TrubineManufacturer',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'trubineModel',
    display: 'TrubineModel',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'trubineModelVersion',
    display: 'TrubineModelVersion',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'trubineType',
    display: 'TrubineType',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'rotorHeight',
    display: 'RotorHeight',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'rotorDiameter',
    display: 'RotorDiameter',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'cutInWindspeed',
    display: 'CutInWindspeed',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'lowCutOutWindspeed',
    display: 'LowCutOutWindspeed',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'highCutOutWindspeed',
    display: 'HighCutOutWindspeed',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'turbulenceIntensity',
    display: 'TurbulenceIntensity',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'windShearId',
    display: 'WindShearId',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'refAnemometerHeight',
    display: 'RefAnemometerHeight',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'minOperatingTemp',
    display: 'MinOperatingTemp',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'maxOperatingTemp',
    display: 'MaxOperatingTemp',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'subgroupOwnershipStatus',
    display: 'SubgroupOwnershipStatus',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  dateCol({
    ident: 'effectiveDate',
    display: 'EffectiveDate',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'transferToEntity',
    display: 'TransferToEntity',
    isFiltered: true,
    sortOrder: 'asc',
  }),
]

export const Wind2PerformanceIoHeaders = [
  strCol({
    ident: 'entityId',
    display: 'NCR ID/NERC ID',
    isFiltered: true,
    sortOrder: 'asc',
    ellipsis: true,
  }),
  strCol({
    ident: 'plantId',
    display: 'Plant ID',
    isFiltered: true,
    sortOrder: 'asc',
    ellipsis: true,
  }),
  intCol({
    ident: 'subgroupId',
    display: 'Subgroup ID',
    isFiltered: true,
    // sortOrder: 'asc',
  }),
  strCol({
    ident: 'subgroupName',
    display: 'Subgroup Name',
    isFiltered: true,
    sortOrder: 'asc',
    ellipsis: true,
    width: 200,
  }),
  intCol({
    ident: 'year',
    display: 'Year',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  intCol({
    ident: 'month',
    display: 'Month',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'status',
    display: 'Status',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'grossactgen',
    display: 'Gross Actual Generation (MWh)',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'expectedGen',
    display: 'Expected Generation (MWh)',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'netactgen',
    display: 'Net Actual Generation (MWh)',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'netmaxcap',
    display: 'Net Max Capacity (MW)',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'activeThrs',
    display: 'Period (Active) THrs',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'contactThrs',
    display: 'Contact THrs',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'rsThrs',
    display: 'Reserve Shutdown THrs',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'forcedThrs',
    display: 'Forced THrs',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'maintenanceThrs',
    display: 'Maintenance THrs',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'plannedThrs',
    display: 'Planned THrs',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'ruThrs',
    display: 'Resource Unavailable THrs',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'inactiveReserveThrs',
    display: 'Inactive Reserve THrs',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'mothballedThrs',
    display: 'Monthballed THrs',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'retiredThrs',
    display: 'Retired THrs',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  // strCol({
  //   ident: 'recordid',
  //   display: 'Recordid',
  //   isFiltered: true,
  //   sortOrder: 'asc',
  // }),
  // strCol({
  //   ident: 'action',
  //   display: 'Action',
  //   isFiltered: true,
  //   sortOrder: 'asc',
  // }),
]
